<template>
  <v-dialog :value="model.active" width="400" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left> {{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ isEditing ? 'Edit' : 'Add' }} Category
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form v-model="model.valid">
          <v-text-field
            outlined
            dense
            hide-details
            :rules="[formRules.required]"
            clearable
            v-virtual-keyboard
            label="Category Name"
            placeholder="Enter Name..."
            v-model="selected.name">
          </v-text-field>

          <div class="mt-2">
            <label>Category Color</label>
            <v-color-picker
              :width="400"
              v-model="selected.color"
              dot-size="25"
              swatches-max-height="200"></v-color-picker>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          @click="createOrEdit"
          :disabled="!model.valid || !model.hasChanges">
          {{ isEditing ? 'Save' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  /* eslint-disable no-unused-vars */
  import formRules from '@Share/config/form-rules';
  import { Category } from '@/scripts/js/forgeModels';
  import { $isEqual } from '@/utils';

  export default {
    name: 'UpdateCategoryPopup',
    props: ['assetid'],
    data() {
      return {
        selected: null,
        selectedCemented: null,
        formRules,
        isEditing: false,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
      };
    },
    methods: {
      open(item) {
        if (item) {
          this.selected = structuredClone(item);
          this.isEditing = true;
        } else {
          this.selected = new Category();
          this.isEditing = false;
        }
        this.cementSelected();
        this.model.active = true;
      },
      saveChanges() {
        this.$emit('updateConfirmed', {
          selected: this.selected,
          index: this.index,
        });
        this.cementSelected();
        this.closeDialog();
      },
      reset() {
        this.model.active = false;
        this.selected = null;
        this.selectedCemented = null;
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },

      createOrEdit() {
        if (this.selected.name == '') return;

        if (this.isEditing) {
          this.$emit('update_category', this.selected);
        } else {
          this.selected.assetId = this.assetid;
          this.$emit('add_new_category', this.selected);
        }
        this.cementSelected();
        this.closeDialog();
      },
    },

    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
